export const fetchShipmentByAccountNumber = async (payload) => {
  //configure api url
  const apiUrl = global.config.premTrackingServiceUrl + "/cargoawbtracking/searchAirWaybillByAccount";
  const response = await fetch(apiUrl, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'X-API-Key': global.config.apiKey
    },
    body: JSON.stringify(payload)
  });

  if (!response.ok) {
    throw new Error(response.statusText);
  }

  const data = await response.json();
  return data;
};



// WEBPACK FOOTER //
// ./src/api/shipmentByAccountNumberApi.js